import { default as _91slug_93xJ6K5jKSE4Meta } from "/home/forge/career.proxify.io/releases/20261023135732/pages/[slug].vue?macro=true";
import { default as accessibility_45statement1uj37jML6FMeta } from "/home/forge/career.proxify.io/releases/20261023135732/pages/accessibility-statement.vue?macro=true";
import { default as _91slug_93Nt1LGUHml1Meta } from "/home/forge/career.proxify.io/releases/20261023135732/pages/article/[slug].vue?macro=true";
import { default as cookie_45policysiyVcVpt7kMeta } from "/home/forge/career.proxify.io/releases/20261023135732/pages/cookie-policy.vue?macro=true";
import { default as _91slug_93J1QVqoE7OhMeta } from "/home/forge/career.proxify.io/releases/20261023135732/pages/events/[slug].vue?macro=true";
import { default as indexmzdmraxkPVMeta } from "/home/forge/career.proxify.io/releases/20261023135732/pages/events/index.vue?macro=true";
import { default as how_45it_45worksUMxKW7sltPMeta } from "/home/forge/career.proxify.io/releases/20261023135732/pages/how-it-works.vue?macro=true";
import { default as indexVuRReg2JznMeta } from "/home/forge/career.proxify.io/releases/20261023135732/pages/index.vue?macro=true";
import { default as jobsA7p7IlkJ2eMeta } from "/home/forge/career.proxify.io/releases/20261023135732/pages/jobs.vue?macro=true";
import { default as journalzRvvfMnqrGMeta } from "/home/forge/career.proxify.io/releases/20261023135732/pages/journal.vue?macro=true";
import { default as privacykOVbsOqw1oMeta } from "/home/forge/career.proxify.io/releases/20261023135732/pages/privacy.vue?macro=true";
import { default as _91slug_93TmJzAXN8QmMeta } from "/home/forge/career.proxify.io/releases/20261023135732/pages/stories/[slug].vue?macro=true";
export default [
  {
    name: "slug",
    path: "/:slug()",
    component: () => import("/home/forge/career.proxify.io/releases/20261023135732/pages/[slug].vue")
  },
  {
    name: "accessibility-statement",
    path: "/accessibility-statement",
    component: () => import("/home/forge/career.proxify.io/releases/20261023135732/pages/accessibility-statement.vue")
  },
  {
    name: "article-slug",
    path: "/article/:slug()",
    component: () => import("/home/forge/career.proxify.io/releases/20261023135732/pages/article/[slug].vue")
  },
  {
    name: "cookie-policy",
    path: "/cookie-policy",
    component: () => import("/home/forge/career.proxify.io/releases/20261023135732/pages/cookie-policy.vue")
  },
  {
    name: "events-slug",
    path: "/events/:slug()",
    component: () => import("/home/forge/career.proxify.io/releases/20261023135732/pages/events/[slug].vue")
  },
  {
    name: "events",
    path: "/events",
    component: () => import("/home/forge/career.proxify.io/releases/20261023135732/pages/events/index.vue")
  },
  {
    name: "how-it-works",
    path: "/how-it-works",
    component: () => import("/home/forge/career.proxify.io/releases/20261023135732/pages/how-it-works.vue")
  },
  {
    name: "index",
    path: "/",
    component: () => import("/home/forge/career.proxify.io/releases/20261023135732/pages/index.vue")
  },
  {
    name: "jobs",
    path: "/jobs",
    component: () => import("/home/forge/career.proxify.io/releases/20261023135732/pages/jobs.vue")
  },
  {
    name: "journal",
    path: "/journal",
    component: () => import("/home/forge/career.proxify.io/releases/20261023135732/pages/journal.vue")
  },
  {
    name: "privacy",
    path: "/privacy",
    component: () => import("/home/forge/career.proxify.io/releases/20261023135732/pages/privacy.vue")
  },
  {
    name: "stories-slug",
    path: "/stories/:slug()",
    component: () => import("/home/forge/career.proxify.io/releases/20261023135732/pages/stories/[slug].vue")
  }
]